<app-logiciel-caisse-list-toolbar

  [(searchTerm)]="searchTerm"

  (searchTermChange)="applySearch()"

  primaryLabel="+ Nouveau gérant"

  (primaryClick)="openCreate(gerantModal)"

></app-logiciel-caisse-list-toolbar>



<div class="table-full-width">

  <div class="table-responsive lc-table-scroll">

    <table class="table table-hover pos-ticket-table">

      <thead class="custom-header">

        <tr>

          <th>Gérant</th>

          <th>Email</th>

          <th>Entrepôts associés</th>

          <th style="width: 120px">Actions</th>

        </tr>

      </thead>

      <tbody>

        <tr *ngIf="loading" class="lc-loading-row">

          <td colspan="4">

            <span class="spinner-border spinner-border-sm mr-1"></span>

            Chargement…

          </td>

        </tr>

        <tr *ngFor="let row of filteredRows" [hidden]="loading">

          <td>{{ gerantLabel(row) }}</td>

          <td>{{ row.email }}</td>

          <td>{{ entrepotsSummary(row) }}</td>

          <td class="d-flex align-items-center flex-nowrap">

            <button

              type="button"

              class="btn btn-sm btn-icon btn-outline-primary mr-50"

              title="Modifier"

              (click)="openEdit(row, gerantModal)"

            >

              <i data-feather="edit" [size]="16"></i>

            </button>

            <button

              type="button"

              class="btn btn-sm btn-icon btn-outline-primary mr-50"

              title="Entrepôts associés"

              (click)="openAssociation(row, assocModal)"

            >

              <i data-feather="link" [size]="16"></i>

            </button>

            <button

              type="button"

              class="btn btn-sm btn-icon btn-outline-danger"

              title="Supprimer"

              (click)="deleteRow(row)"

            >

              <i data-feather="trash-2" [size]="16"></i>

            </button>

          </td>

        </tr>

        <tr *ngIf="!loading && filteredRows.length === 0" class="lc-empty-row">

          <td colspan="4">Pas de données à afficher</td>

        </tr>

      </tbody>

    </table>

  </div>

</div>



<ng-template #gerantModal let-modal>

  <div class="modal-header">

    <h4 class="modal-title">{{ editId ? 'Modifier' : 'Créer' }} gérant</h4>

    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>

  </div>

  <div class="modal-body" [formGroup]="form">

    <div class="form-group">

      <label>Prénom</label>

      <input class="form-control" formControlName="prenom" />

    </div>

    <div class="form-group">

      <label>Nom</label>

      <input class="form-control" formControlName="nom" />

    </div>

    <div class="form-group">

      <label>Email</label>

      <input type="email" class="form-control" formControlName="email" />

    </div>

    <div class="form-group mb-0">

      <label>Mot de passe</label>

      <input type="password" class="form-control" formControlName="password" />

      <small class="form-text text-muted" *ngIf="editId">

        Laissez vide pour conserver le mot de passe actuel.

      </small>

    </div>

  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Annuler</button>

    <button type="button" class="btn btn-primary" (click)="save(modal)" [disabled]="saving || form.invalid">

      Enregistrer

    </button>

  </div>

</ng-template>



<ng-template #assocModal let-modal>

  <div class="modal-header">

    <h4 class="modal-title">Association gérant / entrepôts</h4>

    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>

  </div>

  <div class="modal-body">

    <p class="text-muted mb-2" *ngIf="associationRow">

      Gérant :

      <strong>{{ gerantLabel(associationRow) }}</strong>

      <span class="text-muted">({{ associationRow.email }})</span>

    </p>

    <p class="text-muted small mb-3">

      Sélectionnez les entrepôts que ce gérant peut gérer pour cette station.

    </p>

    <div class="form-group mb-0">

      <label>Entrepôts</label>

      <ng-select

        [items]="entrepotOptions"

        bindLabel="label"

        bindValue="id"

        [multiple]="true"

        [closeOnSelect]="false"

        placeholder="Sélectionner des entrepôts"

        [(ngModel)]="associationEntrepotIds"

      ></ng-select>

    </div>

  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Annuler</button>

    <button

      type="button"

      class="btn btn-primary"

      (click)="saveAssociation(modal)"

      [disabled]="associationSaving"

    >

      Enregistrer

    </button>

  </div>

</ng-template>

